import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { FC } from "react"

import { InventoryAdjustmentHistoryLotQtyChangeCell } from "./InventoryAdjustmentHistoryLotQtyChangeCell"
import { InventoryAdjustmentHistoryStatusCell } from "./InventoryAdjustmentHistoryStatusCell"

import type { AdjustmentHistoryItem } from "@/graphql/codegen/graphql"

interface InventoryAdjustmentHistoryExpandedRowProps {
  row: Row<AdjustmentHistoryItem>
}

export const InventoryAdjustmentHistoryExpandedRow: FC<InventoryAdjustmentHistoryExpandedRowProps> = ({ row }) => {
  const { lots, comments } = row.original

  return (
    <Box className='flex flex-col gap-y-4 bg-primary-100 p-6'>
      {comments.length > 0 && (
        <div className='flex flex-col gap-y-1'>
          <span className='text-sm font-medium text-gray-900'>Comments</span>
          {comments.map((comment) => (
            <span key={comment.commentId} className='text-sm text-gray-700'>
              {comment.value}
            </span>
          ))}
        </div>
      )}
      {lots.length > 0 && (
        <TableContainer className='rounded border border-gray-300'>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Event</TableCell>
                <TableCell>Pallet #</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Lot #</TableCell>
                <TableCell>Batch #</TableCell>
                <TableCell align='right'>Qty Change</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lots.map((lot) => (
                <TableRow key={lot.inventoryAdjustmentLotId}>
                  <TableCell>{lot.event}</TableCell>
                  <TableCell>{lot.palletNbr ?? ""}</TableCell>
                  <TableCell>{lot.location ?? ""}</TableCell>
                  <TableCell>{lot.lotNbr ?? ""}</TableCell>
                  <TableCell>{lot.batchNbr ?? ""}</TableCell>
                  <TableCell align='right'>
                    <InventoryAdjustmentHistoryLotQtyChangeCell qtyChange={lot.qtyChange} />
                  </TableCell>
                  <TableCell>
                    {lot.lotStatus ? <InventoryAdjustmentHistoryStatusCell status={lot.lotStatus} /> : ""}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
